export function CalculateCommission (price:number) {
  return price / 100 * 5;
}
